// removed by extract-text-webpack-plugin
module.exports = {"modalLoading":"qempo_FlightsCurrent_modalLoading-25VpTkO"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/flights/components/FlightCurrent/FlightsCurrent.scss
// module id = 1713
// module chunks = 0